import { render, staticRenderFns } from "./CoverageIterationLineDetail.vue?vue&type=template&id=f3d28e6a&scoped=true"
import script from "./CoverageIterationLineDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoverageIterationLineDetail.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d28e6a",
  null
  
)

export default component.exports